import React from 'react';
import {
  Filter as FilterAdmin,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

import { PeriodoInput } from '../../Components/InputsReactAdmin';
import { STATUS_ATIVO } from '../../utils';

const andarChoices = [
  { id: 1, name: 'Térreo' },
  { id: 2, name: '1º Aéreo' },
  { id: 3, name: '2º Aéreo' },
];

const bandeiraValidadeChoices = [
  { id: 'vencida', name: 'Vencida' },
  { id: 'ate-3-dias', name: 'Vence em até 3 dias' },
  { id: 'ate-7-dias', name: 'Vence em até 7 dias' },
  { id: 'ate-14-dias', name: 'Vence em até 14 dias' },
  { id: 'ate-30-dias', name: 'Vence em até 30 dias' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <ReferenceInput
      fullWidth
      label="Produto"
      source="produto_id"
      reference="produtos_search_filter"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      perPage={10}
      allowEmpty={false}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <ReferenceInput
      fullWidth
      label="Endereço"
      source="endereco_exposicao_produto_id"
      reference="enderecos_exposicao_mercadorias"
      sort={{ field: 'codigo', order: 'ASC' }}
      filterToQuery={(searchText) => ({ codigo: `${searchText}` })}
      perPage={10}
      allowEmpty={false}
    >
      <AutocompleteInput optionText="codigo" />
    </ReferenceInput>
    <SelectInput
      source="andar"
      choices={andarChoices}
      label="Andar"
      allowEmpty={false}
    />
    <PeriodoInput
      source="periodo"
      label="Período"
      defaultValue={{
        start: new Date(),
        end: new Date(),
      }}
    />
    <SelectInput
      source="bandeira"
      choices={bandeiraValidadeChoices}
      label="Urgência da Validade"
      allowEmpty={false}
    />
  </FilterAdmin>
);

export default Filter;
